<template>
  <CModal :show.sync="isOpenModal" addContentClasses="px-4 py-4" :closeOnBackdrop="false">
    <template #header-wrapper>
      <h5>{{ $t('change.organization.parent.modal.title') }}</h5>
    </template>
    <template #body-wrapper>
      <div class="py-5">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
        <CRow class="mb-4">
          <CCol sm="12">
            <label for="organizationSelect" class="font-weight-semi-bold">
              {{ $t(`change.organization.parent.modal.organization.label`) }}
              <span class="text-danger">*</span>
            </label>
            <v-select
              id="organizationSelect"
              v-model="selectedEligibleOrganization"
              class="no-close border-gray-300 rounded select"
              label="companyName"
              :options="eligibleOrganizations"
              :loading="isLoadingEligibleOrganizations"
              :disabled="isLoadingEligibleOrganizations || isLoadingSubmit"
              :searchable="true"
              @input="handleOrganizationSelect"
            />
          </CCol>
        </CRow>
        <CRow class="mb-4" v-if="selectedEligibleOrganization">
          <CCol sm="12">
            <label for="balanceTypeSelect" class="font-weight-semi-bold">
              {{ $t(`change.organization.parent.modal.balance-type.label`) }}
              <span class="text-danger">*</span>
            </label>
            <v-select
              id="balanceTypeSelect"
              v-model="selectedOrganizationBalanceType"
              class="no-close border-gray-300 rounded select"
              :options="organizationBalanceTypes"
              :loading="isLoadingOrganizationBalanceTypes"
              :disabled="isLoadingOrganizationBalanceTypes || isLoadingSubmit"
              :searchable="true"
            />
          </CCol>
        </CRow>
      </div>
    </template>
    <template #footer-wrapper>
      <div class="text-right">
        <CButton class="px-4 py-2 mr-3" color="white" :disabled="isLoadingSubmit" @click="closeModal()">
          {{ $t('change.organization.parent.modal.button.cancel') }}
        </CButton>
        <CButton class="px-4 py-2" color="primary" :disabled="$v.$invalid || isLoadingSubmit" @click="submit">
          <CSpinner v-if="isLoadingSubmit" class="mr-1 align-middle" style="width: 1rem; height: 1rem" />
          {{ $t('change.organization.parent.modal.button.confirm') }}
        </CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'
import vSelect from 'vue-select'
import { required } from 'vuelidate/lib/validators'

// TODO: MAPEAR ERROS DE BACK (tradução)

export default {
  name: 'ChangeOrganizationParentModal',
  components: { MenssageAlert, vSelect },
  mixins: [validationMixin],
  validations: {
    selectedEligibleOrganization: { required },
    selectedOrganizationBalanceType: { required },
  },
  data() {
    return {
      isOpenModal: false,
      messages: [],
      isLoadingEligibleOrganizations: false,
      eligibleOrganizations: [],
      selectedEligibleOrganization: undefined,
      isLoadingOrganizationBalanceTypes: false,
      organizationBalanceTypes: [],
      selectedOrganizationBalanceType: undefined,
      selectedSuborganizationId: undefined,
      isLoadingSubmit: false,
    }
  },
  computed: {
    organizationTypesValues() {
      return {
        1: this.$t('settings.organization.formOrganization.form.input-label.consumes-from-parent'),
        2: this.$t('settings.organization.formOrganization.form.input-label.distributed-by-parent'),
        3: this.$t('settings.organization.formOrganization.form.input-label.independent'),
      }
    },
  },
  methods: {
    openModal(organizationId) {
      this.isOpenModal = true
      this.selectedSuborganizationId = organizationId
      this.getEligibleOrganizations(organizationId)
    },
    clearData() {
      this.selectedEligibleOrganization = undefined
      this.selectedOrganizationBalanceType = undefined
    },
    closeModal() {
      this.isOpenModal = false
      this.clearData()
    },
    async getEligibleOrganizations(organizationId) {
      try {
        this.isLoadingEligibleOrganizations = true
        const params = {
          page: 0,
          count: 9999,
        }
        const response = await services.getEligibleDestinationOrganizations(organizationId, params)
        this.eligibleOrganizations = response.data.data.items
      } catch (error) {
        const errorCode = error?.response?.data?.error?.code || error?.response?.data?.errorCode || error?.response?.data?.messages[0]?.error?.code

        if (!errorCode) {
          this.messages = [
            {
              status: 'danger',
              text: this.$t(`error.codes.DEFAULT`),
            },
          ]
          return
        }

        this.messages = [
          {
            status: 'danger',
            text: this.$t(`general.errors.${errorCode}`),
          },
        ]
      } finally {
        this.isLoadingEligibleOrganizations = false
      }
    },
    async getOrganizationBalanceTypes(organizationId) {
      try {
        this.isLoadingOrganizationBalanceTypes = true
        const response = await services.getOrganizationBalanceTypes(organizationId)

        if (Array.isArray(response.data.data)) {
          let result = response.data.data.map((elm) => {
            return {
              value: elm,
              label: this.organizationTypesValues[elm],
            }
          })
          this.organizationBalanceTypes = result
        }
      } catch (error) {
        const errorCode = error?.response?.data?.error?.code || error?.response?.data?.errorCode || error?.response?.data?.messages[0]?.error?.code

        if (!errorCode) {
          this.messages = [
            {
              status: 'danger',
              text: this.$t(`error.codes.DEFAULT`),
            },
          ]
          return
        }

        this.messages = [
          {
            status: 'danger',
            text: this.$t(`general.errors.${errorCode}`),
          },
        ]
      } finally {
        this.isLoadingOrganizationBalanceTypes = false
      }
    },
    async submit() {
      try {
        this.isLoadingSubmit = true
        const body = {
          newParentOrganizationId: this.selectedEligibleOrganization.organizationId,
          organizationBalanceConfigType: this.selectedOrganizationBalanceType.value,
        }
        await services.changeParentOrganization(this.selectedSuborganizationId, body)
        this.$emit('parentChanged')
        this.closeModal()
      } catch (error) {
        const errorCode = error?.response?.data?.error?.code || error?.response?.data?.errorCode || error?.response?.data?.messages[0]?.error?.code
        if (!errorCode) {
          this.messages = [
            {
              status: 'danger',
              text: this.$t(`error.codes.DEFAULT`),
            },
          ]
          return
        }

        this.messages = [
          {
            status: 'danger',
            text: this.$t(`general.errors.${errorCode}`),
          },
        ]
      } finally {
        this.isLoadingSubmit = false
      }
    },
    handleOrganizationSelect(inputValue) {
      this.selectedOrganizationBalanceType = undefined
      this.getOrganizationBalanceTypes(inputValue.organizationId)
    },
  },
}
</script>
